import { gql } from '@apollo/client';

export const CREATE_COLLECTION = gql`
  mutation CreateBookmarkCollection($name: String!) {
    createBookmarkCollection(name: $name) {
      entity {
        id
        name
      }
      errors {
        code
        path
        message
      }
    }
  }
`;

export const ADD_TO_COLLECTION = gql`
  mutation BulkInsertAdsIntoBookmarkCollections(
    $bookmarkCollectionIds: [ID!]!
    $adLegacyIds: [ID!]
  ) {
    bulkInsertAdsIntoBookmarkCollections(
      bookmarkCollectionIds: $bookmarkCollectionIds
      adLegacyIds: $adLegacyIds
    ) {
      entity {
        id
      }
      errors {
        code
        path
        message
      }
    }
  }
`;

export const DESTROY_COLLECTION = gql`
  mutation DestroyBookmarkCollection($bookmarkCollectionId: ID!) {
    destroyBookmarkCollection(bookmarkCollectionId: $bookmarkCollectionId) {
      entity
      errors {
        code
        path
        message
      }
    }
  }
`;

export const UPDATE_COLLECTION = gql`
  mutation UpdateBookmarkCollection(
    $bookmarkCollectionId: ID!
    $name: String!
  ) {
    updateBookmarkCollection(
      bookmarkCollectionId: $bookmarkCollectionId
      name: $name
    ) {
      entity {
        id
        name
      }
      errors {
        code
        path
        message
      }
    }
  }
`;

export const REMOVE_FROM_COLLECTION = gql`
  mutation RemoveFromCollection(
    $bookmarkCollectionIds: [ID!]!
    $adLegacyIds: [ID!]
  ) {
    bulkRemoveAdsFromBookmarkCollections(
      bookmarkCollectionIds: $bookmarkCollectionIds
      adLegacyIds: $adLegacyIds
    ) {
      errors {
        code
        path
        message
      }
    }
  }
`;

export const BULK_REMOVE_BOOKMARKS = gql`
  mutation BulkDestroyBookmarks($adIds: [ID!]!, $adLegacyIds: [ID!]!) {
    bulkDestroyBookmarks(adIds: $adIds, adLegacyIds: $adLegacyIds) {
      entity
      errors {
        message
        path
      }
    }
  }
`;
